import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ReportOption } from 'src/app/interfaces/reports.interface';
import { ReportsService } from 'src/app/services/reports.service';
import { LookupProductsCollectionComponent } from './product-collection/product-collection.component';
import { ProductCollectionService } from 'src/app/services/product-collection.service';
import { NewReportHistoricalDataComponent } from '../common/historical-data/historical-data.component';
import { LookupProductsDetailsComponent } from './product-details/product-details.component';

@Component({
  selector: 'app-lookup-products',
  templateUrl: './lookup-products.component.html',
  styleUrls: ['./lookup-products.component.scss']
})
export class LookupProductsComponent implements OnInit {
  @ViewChild('lookupProductsCollectionComp') lookupProductsCollectionComp!: LookupProductsCollectionComponent;
  @ViewChild('lookupProductsDetailsComp') lookupProductsDetailsComp!: LookupProductsDetailsComponent;
  @ViewChild('historicalDataComp') historicalDataComp!: NewReportHistoricalDataComponent;

  generatingReport: boolean = false;
  generatingCount: boolean = false;

  reportName: string = '';

  reportOptions: Record<string, ReportOption> = {
    productCollection: {
      title: 'Product Collection',
      subtitle: 'Additional Fields',
    },
    productDetails: {
      title: 'Product Details',
      subtitle: 'Additional Fields',
    },
    historicalData: {
      title: 'Historical Data',
      subtitle: 'Additional Fields',
    },
  };
  reportOptionsKeys: string[] = Object.keys(this.reportOptions);

  constructor(
    public reportsService: ReportsService,
    public modal: NgbActiveModal,
    private toastr: ToastrService,
    private productCollectionService: ProductCollectionService
  ) { }

  ngOnInit(): void {
  }

  stepBack() {
    this.reportsService.selectedFeature = null;
  }

  onChangeValue(reportOption: ReportOption, reportRef: HTMLElement) {
    if (reportOption.checked) {
      $(reportRef).find('.option-content').slideDown(() => {
        $(reportRef).addClass('opened');
      });
    } else {
      $(reportRef).find('.option-content').slideUp(() => {
        $(reportRef).removeClass('opened');
      });
    }
  }

  getReportParams() {
    const productCollectionReqParams: any = this.lookupProductsCollectionComp.getReportRequestParams();
    const productDetailsReqParams: any = this.lookupProductsDetailsComp.getReportRequestParams();

    const reqParams = { ...productCollectionReqParams, ...productDetailsReqParams };
    reqParams.reportName = this.reportName;
    if (this.reportOptions['productDetails'].checked) {
      reqParams.withPdv2 = true;
    }
    if (this.reportOptions['historicalData'].checked) {
      const historyReqParams: any = this.historicalDataComp.getReportRequestParams();
      reqParams.withHistory = true;
      reqParams.signals = historyReqParams.signals;
      reqParams.dateRange = historyReqParams.dateRange;
    }
    return reqParams;
  }

  generateReport() {
    this.generatingReport = true;
    this.productCollectionService.generateReport(this.getReportParams())
      .finally(() => {
        this.generatingReport = false;
      })
      .then(() => {
        this.modal.close('reportGenerated');
      })
      .catch((err: any) => {
        let msg = 'Something went wrong.';
        if (err && err.error && err.error.statusMessage) {
          msg = err.error.statusMessage;
        }
        this.toastr.error(msg);
      });
  }

  generateCount() {
    this.generatingCount = true;
    this.productCollectionService.generateCount(this.getReportParams())
      .finally(() => {
        this.generatingCount = false;
      })
      .then(() => {
        this.modal.close('countGenerated');
      })
      .catch((err: any) => {
        let msg = 'Something went wrong.';
        if (err && err.error && err.error.statusMessage) {
          msg = err.error.statusMessage;
        }
        this.toastr.error(msg);
      });
  }

  canGenerateReport(): boolean {
    if (!this.reportName) return false;
    if (this.reportOptionsKeys.filter(key => this.reportOptions[key].checked).length === 0) return false;
    const reqParams: any = this.lookupProductsCollectionComp.getReportRequestParams();
    if (Object.keys(reqParams).filter(param => param !== 'additionalFields').length === 0) return false;

    const historyReqParams: any = this.historicalDataComp.getReportRequestParams();
    if (this.reportOptions['historicalData'].checked && (!historyReqParams.signals || !historyReqParams.dateRange)) return false;

    return true;
  }

}
